import React from 'react';
import * as S from './PartnerAdvantage.styles';
import IconSelector from '@ibibo/icon-selector';

const PartnerAdvantage = () => {
    return(
        <S.PartnerAdvMainWrap>
            <S.PartnerAdvOuterWrap>
                <S.PartnerAdvHeadWrap>
                    <S.PartnerAdvHeadText>myPartner Advantages</S.PartnerAdvHeadText>
                    <S.PartnerAdvSubText>It is a feature loaded platform!</S.PartnerAdvSubText>
                </S.PartnerAdvHeadWrap>
                <S.PartnerAdvInnerWrap>
                    <S.PartnerAdvBannerWrap>
                        <S.PartnerAdvBannerImg src="https://mypartnerimgak.mmtcdn.com/media/screen-banner.png" alt="screen"/>
                    </S.PartnerAdvBannerWrap>
                    <S.PartnerAdvInfoWrap>
                        <S.PartnerAdvInfoOuterWrap>
                            <S.PartnerAdvInfoIconWrap>
                                <IconSelector iconKey='easyAccess' />
                            </S.PartnerAdvInfoIconWrap>
                            <S.PartnerAdvInfoTextWrap>
                                <S.PartnerAdvInfoText>Easy access to booking and payment records</S.PartnerAdvInfoText>
                            </S.PartnerAdvInfoTextWrap>
                        </S.PartnerAdvInfoOuterWrap>
                        <S.PartnerAdvInfoOuterWrap>
                            <S.PartnerAdvInfoIconWrap>
                                <IconSelector iconKey='quickBook' />
                            </S.PartnerAdvInfoIconWrap>
                            <S.PartnerAdvInfoTextWrap>
                                <S.PartnerAdvInfoText>Easy and quick post booking modifications</S.PartnerAdvInfoText>
                            </S.PartnerAdvInfoTextWrap>
                        </S.PartnerAdvInfoOuterWrap>
                        <S.PartnerAdvInfoOuterWrap>
                            <S.PartnerAdvInfoIconWrap>
                                <IconSelector iconKey='safeHyg' />
                            </S.PartnerAdvInfoIconWrap>
                            <S.PartnerAdvInfoTextWrap>
                                <S.PartnerAdvInfoText>Safe and hygienic stays with MySafety compliant properties</S.PartnerAdvInfoText>
                            </S.PartnerAdvInfoTextWrap>
                        </S.PartnerAdvInfoOuterWrap>
                        <S.PartnerAdvInfoOuterWrap>
                            <S.PartnerAdvInfoIconWrap>
                                <IconSelector iconKey='bestClass' />
                            </S.PartnerAdvInfoIconWrap>
                            <S.PartnerAdvInfoTextWrap>
                                <S.PartnerAdvInfoText>Best-in-class cancellation policies</S.PartnerAdvInfoText>
                            </S.PartnerAdvInfoTextWrap>
                        </S.PartnerAdvInfoOuterWrap>
                        <S.PartnerAdvInfoOuterWrap>
                            <S.PartnerAdvInfoIconWrap>
                                <IconSelector iconKey='shareWhatsapp' />
                            </S.PartnerAdvInfoIconWrap>
                            <S.PartnerAdvInfoTextWrap>
                                <S.PartnerAdvInfoText>Share options directly with customers via WhatsApp</S.PartnerAdvInfoText>
                            </S.PartnerAdvInfoTextWrap>
                        </S.PartnerAdvInfoOuterWrap>
                        <S.PartnerAdvInfoOuterWrap>
                            <S.PartnerAdvInfoIconWrap>
                                <IconSelector iconKey='confimrPrint' />
                            </S.PartnerAdvInfoIconWrap>
                            <S.PartnerAdvInfoTextWrap>
                                <S.PartnerAdvInfoText>Get booking confirmations printed under your agency’s logo</S.PartnerAdvInfoText>
                            </S.PartnerAdvInfoTextWrap>
                        </S.PartnerAdvInfoOuterWrap>
                    </S.PartnerAdvInfoWrap>
                </S.PartnerAdvInnerWrap>
            </S.PartnerAdvOuterWrap>
        </S.PartnerAdvMainWrap>
    )
}

export default PartnerAdvantage;